import React, { FC } from 'react'
import { Typography, Link } from '@mui/material'
import { Formik } from 'formik'
import { IFormProps, isMultiLoginApp } from 'utils'
import {
  Module,
  ModuleHeader,
  ModuleBody,
  CustomAlert,
  CustomTextField,
  ButtonContainer,
  CustomButton,
  PasswordComplexityRequirement,
} from 'components'

interface IAdditionalProps extends IFormProps {
  passwordPolicy: any
  handleCancel: (e: any) => void
}

const ResetPasswordForm: FC<IAdditionalProps> = ({
  isModuleInitialized,
  passwordPolicy,
  initialValues,
  validationSchema,
  handleSubmit,
  handleCancel,
  serviceError,
}) => (
  <Module isModuleInitialized={isModuleInitialized} serviceError={serviceError}>
    <ModuleHeader title="Reset Your Password">
      <Typography variant="body1">
        {isMultiLoginApp()
          ? 'Enter a new password for your multi login. Your password must meet all of the following requirements'
          : 'Almost done. Please enter your new password.'}
      </Typography>
      <CustomAlert severity="error">{serviceError}</CustomAlert>
    </ModuleHeader>

    <ModuleBody>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          handleSubmit: onSubmit,
          dirty,
          isValid,
          isSubmitting,
          getFieldProps,
          getFieldMeta,
          setFieldTouched,
          setFieldError,
          touched,
          errors,
          values,
        }) => (
          <form onSubmit={onSubmit}>
            <CustomTextField
              autoFocus
              id="newPassword"
              type="password"
              label="New Password"
              hasServiceError={Boolean(serviceError)}
              touched={touched}
              errors={errors}
              values={values}
              getFieldMeta={getFieldMeta}
              setFieldTouched={setFieldTouched}
              setFieldError={setFieldError}
              {...getFieldProps('newPassword')}
            />

            <PasswordComplexityRequirement
              passwordPolicyComplexity={passwordPolicy?.complexity}
              newPassword={values.newPassword}
            />

            <CustomTextField
              id="repeatPassword"
              type="password"
              label="Confirm New Password"
              hasServiceError={Boolean(serviceError)}
              touched={touched}
              errors={errors}
              values={values}
              getFieldMeta={getFieldMeta}
              setFieldTouched={setFieldTouched}
              setFieldError={setFieldError}
              {...getFieldProps('repeatPassword')}
            />

            <ButtonContainer
              primary={
                <CustomButton
                  type="submit"
                  disabled={!dirty || !isValid || isSubmitting}
                >
                  Reset Password
                </CustomButton>
              }
              secondary={
                <Link href="#" onClick={handleCancel} color="primary">
                  {isMultiLoginApp()
                    ? 'Return to Multi Login'
                    : 'Return to Login'}
                </Link>
              }
            />
          </form>
        )}
      </Formik>
    </ModuleBody>
  </Module>
)

export default ResetPasswordForm
